import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Channel management moved to the top-level `/channels` hub. This route stays
 * as a redirect so old links, bookmarks, and OAuth callbacks keep working.
 */
export const Route = createFileRoute("/(app)/settings/social-accounts")({
  beforeLoad: () => {
    throw redirect({ to: "/channels", replace: true });
  },
});
